/**
 * OpenPanel Analytics Initialization for Backoffice App
 *
 * Sets up OpenPanel analytics to run side-by-side with PostHog.
 * Call initOpenPanel() after DI is ready.
 */

import { resolve } from "ui-common/di";
import type { IOpenPanelService } from "ui-common/services/openpanel/types";

/**
 * Initialize OpenPanel for the backoffice app.
 * Should be called in requestAnimationFrame block after DI is ready.
 */
export function initOpenPanel(): void {
  const openpanelService = resolve<IOpenPanelService>("openpanelService");

  openpanelService.initialize();

  openpanelService.setGlobalProperties({
    app: "backoffice",
  });
}
